import {
  Box,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { CSSProperties, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutsConfig, MainContext } from "../context/MainContextProvider";

export type AsideMenuItemProps = {
  title: string;
  icon: (style: CSSProperties) => React.ReactNode;
  route?: string;
  onClick?: () => void;
  cantShow?: boolean;
  disabled?: boolean;
  isShrunken: boolean;
  isMobile?: boolean;
  isAccordionitem?: boolean;
  URI?: string;
};
export function AsideMenuItem(props: AsideMenuItemProps) {
  const {
    title,
    icon,
    route,
    onClick,
    disabled,
    isShrunken,
    isMobile,
    isAccordionitem,
  } = props;
  const { theme, layout } = useContext(MainContext);
  const navigate = useNavigate();
  const path = window.location.pathname;
  const isActive = route ? path.includes(route) && path === route : false;
  const iconStyle: CSSProperties = {
    color: isActive ? layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : theme.primaryTextColor : "#8F969E",
    width: "1.5rem",
    height: "1.5rem",
  };
  return (
    <Tooltip title={isShrunken ? title : ""} placement="right">
      <>
        <ListItem disablePadding>
          <ListItemButton
            disabled={disabled}
            sx={{
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              paddingLeft: isAccordionitem ? LayoutsConfig.LayoutTwo ? "16px" : "32px" : undefined,
            }}
            onClick={() => {
              if (onClick) {
                onClick();
              } else route && navigate(route);
            }}
          >
            <Box sx={{ paddingRight: isShrunken ? "0px" : "8px" }}>
              {icon(iconStyle)}
            </Box>
            {!isShrunken && (
              <ListItemText
                primaryTypographyProps={{
                  sx: {
                    fontSize: isMobile ? "1.125rem" : "14px",
                    color: isActive ? layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : theme.primaryTextColor : "#8F969E",
                  },
                }}
                primary={title}
              />
            )}
          </ListItemButton>
        </ListItem>
        <Divider
          sx={{
            backgroundColor: theme.secondaryTextColor,
            display: isMobile ? undefined : "none",
          }}
        />
      </>
    </Tooltip>
  );
}
